import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
	root: {
		width: 24,
		height: 24,
		// backgroundColor: '#BCBBD0',

		'& > svg': {
			// margin: theme.spacing(2),
			// width: 24,
			// height: 24,
		},
	},
}));

function HomeIcon(props) {
	return (
		<svg width="24" height="24" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path fillRule="evenodd" clipRule="evenodd" d="M4.22568 13.2218C3.44251 13.9758 3 15.0161 3 16.1033V25C3 27.2091 4.79086 29 7 29H14V24C14 22.8954 14.8954 22 16 22C17.1046 22 18 22.8954 18 24V29H25C27.2091 29 29 27.2091 29 25V16.1033C29 15.0161 28.5575 13.9758 27.7743 13.2218L18.7743 4.55659C17.2254 3.06528 14.7746 3.06528 13.2257 4.55659L4.22568 13.2218ZM17 12C17 12.5523 16.5523 13 16 13C15.4477 13 15 12.5523 15 12C15 11.4477 15.4477 11 16 11C16.5523 11 17 11.4477 17 12Z" fill={props.fill} />
		</svg>
	);
}

export default function SvgIconsColor(props) {
	const classes = useStyles();

	return (
		<div className={classes.root}>
			<HomeIcon fill={props.fill} />
		</div>
	);
}